/**
 * Product comparison field table.
 *
 * This file only defines which SPEC rows are compared. Product values continue
 * to come from the existing Product Specs - Custom section on each product page.
 * Add historical/editorial spellings to aliases instead of duplicating values.
 */
/**
 *  key：字段唯一标识，不能重复。
    label：对比弹窗显示的标题。
    aliases：产品 SPEC 中可能填写的标题名称。系统会依次查找，找不到就显示 N/A。
 */
window.ieGeekProductCompareFields = Object.freeze([
  { key: 'resolution', label: window.ieGeekRedesignStrings?.resolution || "Resolución", aliases: ["Resolución", "Resolución de vídeo", "Resolución de video", 'Resolution', 'Video Resolution'] },
  { key: 'connectivity', label: window.ieGeekRedesignStrings?.connectivity || "Conectividad", aliases: ["Conectividad", "Conexión de red", "Tipo de conexión", 'Connectivity', 'Network Connection', 'Connection Type', 'Wi-Fi', 'Wireless Technology'] },
  { key: 'power_source', label: window.ieGeekRedesignStrings?.power_source || "Fuente de alimentación", aliases: ["Fuente de alimentación", "Alimentación", "Alimentación CC", "Alimentación de la cámara", 'Power Source', 'Power Supply', 'Power  Supply', 'Camera Power', 'DC Power'] },
  { key: 'recording_mode', label: window.ieGeekRedesignStrings?.recording_mode || "Modo de grabación", aliases: ["Modo de grabación", "Grabación", 'Recording Mode', 'Recording'] },
  // { key: 'special_features', label: 'Special Features', aliases: ['Special Features', 'Other Smart Features'] },
  // { key: 'category', label: 'Category', aliases: ['Category'] },
  // { key: 'brand', label: 'Brand', aliases: ['Brand', 'Manufacturer'] },
  // { key: 'sku', label: 'SKU', aliases: ['SKU'] },
  // { key: 'description', label: 'Description', aliases: ['Description'] },
  // { key: 'product_type', label: 'Product Type', aliases: ['Product Type'] },
  // { key: 'availability', label: 'Availability', aliases: ['Availability'] },
  // { key: 'price_range', label: 'Price Range', aliases: ['Price Range', 'Price'] }
]);
